exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-7d743cae] .template-column{border:2px dotted black;padding:5px;margin:15px}[data-v-7d743cae] .template-column.selected-column{border:2px dashed gray}\n", ""]);

